<template>
  <div
    class="BaseSelectForm"
    :name="$attrs.name"
  >
    <label :for="tag">{{ label }}</label>

    <select
      :id="tag"
      v-model="innerValue"
      :name="tag"
    >
      <option
        class="placeholder"
        value=""
        disabled
      >
        {{ $t('SELECT.PLACEHOLDER') }}
      </option>
      <option
        v-for="(option, i) in options"
        :key="i"
        :value="i"
      >
        {{ option }}
      </option>
    </select>

    <slot name="error" />
  </div>
</template>

<script>
import ModelMixin from '@/mixins/ModelMixin';

export default {
  mixins: [ModelMixin],

  // inheritAttrs: false,

  props: {
    label: {
      type: String,
      default: undefined,
    },

    tag: {
      type: String,
      default: undefined,
    },

    options: {
      type: null,
      required: true,
    },
  },

  computed: {
    inputAttributes() {
      return Object.assign({}, this.$attrs);
    },
  },

};
</script>


<style lang="scss" scoped>
.BaseSelectForm {
  select {
    border: solid 2px black;
    font-size: 15px;
    height: 35px;
    padding-left: 10px;
    // background: var(--color-primary);

    border-radius: 12px;
    outline: none;
    option[disabled] {
      color: #797979;
      background: #b3b3b3;
    }
  }
}
</style>
